import axios, { AxiosResponse } from 'axios';
import { DeleteOrderInput } from 'views/order-feed/features/my-supply-plan/types/delete-order-input.type';

const deletionReason = 'NoneOfTheAbove';

// DELETE
// /ewosapi/v1/order/{orderNumber}?customerErpId={customerErpId}&deletionReason=NoneOfTheAbove
export const deleteOrder = async (orderNumber: string, deleteOrderInput: DeleteOrderInput): Promise<AxiosResponse> => {
  const params = new URLSearchParams({
    customerErpId: deleteOrderInput.customerErpId,
    deletionReason: deletionReason,
  });

  return await axios.delete<AxiosResponse>(`/ewosapi/v1/order/${orderNumber}?${params.toString()}`);
};